import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../common/api";
import { toast } from "react-toastify";
import toastCommonProps from "../../common/toast";
//Additional disease questions
export const fetchAnswerList = createAsyncThunk(
  "questionDisease/fetchAnswerList",
  async (params) => {
    const res = await api.get(`/user/searchForUserId/${params}`);
    if (res.data.ok) {
      return res.data;
    }
  }
);
export const fetchQuestion = createAsyncThunk(
  "questionDisease/fetchQuestion",
  async () => {
    const res = await api.get(`/base/getHealthQuestionAdditional`);
    return res.data;
  }
);

export const searchHospital = createAsyncThunk(
  "questionDisease/searchHospital",
  async (param) => {
    const res = await api.post("/base/searchHospital", param);
    return res.data;
  }
);

export const searchMedicine = createAsyncThunk(
  "questionDisease/searchMedicine",
  async (param) => {
    const res = await api.post("/base/searchMedicine", param);
    return res.data;
  }
);
export const saveAnswer = createAsyncThunk(
  "questionDisease/saveAnswer",
  async (params) => {
    // const res = await api.post(`/user/inputUserHealth`, params);
    const res = await api.post(`/user/inputUserHealthNew`, params);
    return res.data;
  }
);

const initialState = {
  questionLists: [],
  i: 0,
  prevI: [0],
  gettingAnswers: {},
  questionListsStatus: null,
  resultLists: null,
  // hospitalLists: null,
  medicineList: null,
};

const questionDiseaseSlice = createSlice({
  name: "Disease Questionnaire",
  initialState,
  reducers: {
    increment: (state) => {
      state.i += 1;
      state.prevI = [...state.prevI, state.i];
    },
    decrement: (state) => {
      if (state.i <= 0) {
        toast(
          <p>This is question 1</p>,
          toastCommonProps("bottom-center", "toast_alert")
        );
      } else {
        state.i -= 1;
        state.prevI = [...state.prevI, state.i];
      }
    },
    incrementByAmount: (state, action) => {
      state.i += action.payload;
      state.prevI = [...state.prevI, state.i];
    },
    goBackByAmount: (state) => {
      const filter = state.prevI.filter(
        (el, idx) => idx < state.prevI.length - 1
      ); //Delete last number
      state.prevI = [...filter];
      state.i = state.prevI[state.prevI.length - 1];
    },
    resetI: (state) => {
      state.i = 0;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(fetchQuestion.pending, (state) => {
      state.questionListsStatus = "pending";
    });
    builder.addCase(fetchQuestion.fulfilled, (state, action) => {
      state.questionListsStatus = "success";
      state.questionLists = action.payload.questionList;
    });
    builder.addCase(fetchQuestion.rejected, (state) => {
      state.questionListsStatus = "rejected";
    });
    builder.addCase(fetchAnswerList.fulfilled, (state, action) => {
      state.gettingAnswers = action.payload.user.userHealth;
    });
    builder.addCase(searchHospital.fulfilled, (state, action) => {
      // state.hospitalLists = action.payload.hospitalList;
    });
    builder.addCase(searchMedicine.fulfilled, (state, action) => {
      // state.medicineList = action.payload.medicineList;
    });
    // builder.addCase(fetchSurveyResult.fulfilled, (state, action) => {
    //   state.resultLists = action.payload;
    // });
  },

  // {
  //   [fetchQuestion.pending]: (state) => {
  //     state.questionListsStatus = "pending";
  //   },
  //   [fetchQuestion.fulfilled]: (state, action) => {
  //     state.questionListsStatus = "success";
  //     state.questionLists = action.payload.questionList;
  //   },
  //   [fetchQuestion.rejected]: (state) => {
  //     state.questionListsStatus = "rejected";
  //   },
  //   [fetchAnswerList.fulfilled]: (state, action) => {
  //     state.gettingAnswers = action.payload.user.userHealth;
  //   },
  //   [searchHospital.fulfilled]: (state, action) => {
  //     // state.hospitalLists = action.payload.hospitalList
  //   },
  //   [searchMedicine.fulfilled]: (state, action) => {
  //     // state.medicineList = action.payload.medicineList;
  //   },
  //   //   [fetchSurveyResult.fulfilled]: (state, action) => { state.resultLists = action.payload; },
  // },
});

export const {
  increment,
  decrement,
  incrementByAmount,
  goBackByAmount,
  resetI,
} = questionDiseaseSlice.actions;

export default questionDiseaseSlice.reducer;
